import { makeStyles, Text, Title1, Title2 } from "@fluentui/react-components";
import { dolphinTokens } from "../utils/Theme";

interface ILegalContentProps {
    title: string;
    subtitle?: string;
    updated: string;
    sections: any[];
}

const useStyles = makeStyles({
    container: {
        padding: "1rem 2rem",
        fontSize: "1.125rem",
        margin: "0 auto",
        maxWidth: "100%",

        "& h1": {
            width: "100%",
            textAlign: "center",
            fontWeight: "bold",
        },

        "& > div": {
            width: "100%",
            margin: "0 auto",
            lineHeight: 1.6
        }
    },
    subtitle: {
        fontSize: "1.5rem",
        lineHeight: 1.35,
        fontWeight: "light",
        textAlign: "center",
        color: dolphinTokens.colorLightBlue,
    },
    updated: {
        fontSize: "1.125rem",
        lineHeight: 1.35,
        fontWeight: "light",
        textAlign: "center",
        color: dolphinTokens.colorDarkBlue,
    },
    caption: {
        fontWeight: "bold"
    }
});

export default function LegalContent(props: ILegalContentProps) {
    const { title, subtitle, updated, sections } = props;

    const styles = useStyles();

    return (
        <div className={styles.container}>
            <Title1 block as="h1">
                {title}
            </Title1>

            <Text block as="p" className={styles.updated}>
                {updated}
            </Text>
            
            {
                subtitle &&
                <Text block as="p" className={styles.subtitle}>
                    {subtitle}
                </Text>
            }

            {
                sections.map((section, index) => (
                    <div key={index}>
                        {
                            section.title &&
                            <Title2 as="h2">{section.title}</Title2>
                        }

                        {
                            section.content &&
                            <div>
                                {
                                    section.content
                                        .map((item: string, index: number) => {
                                            if (item.startsWith("CAPTION:")) {
                                                const caption = item.replace("CAPTION:", "").trim();
                                                return (
                                                    <Text block as="p" key={index} className={styles.caption}>
                                                        {caption}
                                                    </Text>
                                                );
                                            }
                                            
                                            return <Text block as="p" key={index}>{item}</Text>;
                                        })
                                }
                            </div>
                        }

                        {
                            section.list &&
                            <ul>
                                {
                                    section.list
                                        .map((item: string, index: number) => (
                                            <li key={index}>
                                                <Text>{item}</Text>
                                            </li>
                                        ))
                                }
                            </ul>
                        }
                    </div>
                ))
            }
        </div>
    );
}